import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export default function useAuth() {
     const [session, setSession] = useState(null);
     const [loading, setLoading] = useState(true);

     useEffect(() => {
          supabase.auth.getSession().then(({ data: { session } }) => {
               setSession(session);
               setLoading(false);
          });

          const { data: { subscription } } = supabase.auth.onAuthStateChange(
               (_event, session) => {
                    setSession(session);
               }
          );

          return () => subscription.unsubscribe();
     }, []);

     const signIn = async (email, password) => {
          const { error } = await supabase.auth.signInWithPassword({
               email,
               password,
          });
          return { error };
     };

     const signOut = async () => {
          await supabase.auth.signOut();
     };

     return { session, loading, signIn, signOut };
}
